module.exports = __webpack_public_path__ + "img/man_running.5e597097.gif";